import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {HIRING_PLAN_REQUEST} from "../hiringPlanReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${HIRING_PLAN_REQUEST}${START}`:
            return true;
        case `${HIRING_PLAN_REQUEST}${SUCCESS}`:
            return false;
        case `${HIRING_PLAN_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};